var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRechargeMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 6.5C15.9377 4.78752 15.7251 3.75009 14.9988 3.02513C13.9718 2 12.3188 2 9.01289 2C5.70698 2 4.05403 2 3.02701 3.02513C2 4.05025 2 5.70017 2 9V15C2 18.2998 2 19.9497 3.02701 20.9749C4.05403 22 5.70698 22 9.01289 22C12.3188 22 13.9718 22 14.9988 20.9749C15.7251 20.2499 15.9377 19.2125 16 17.5",
    stroke: "#FFC000",
    strokeWidth: 1.54,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 19H10",
    stroke: "#FFC000",
    strokeWidth: 1.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11.9898V11.9988M20.0483 16.4902C21.2541 15.3386 22 13.7476 22 11.9902C22 10.2329 21.2541 8.64188 20.0483 7.49023M18 9.74023C18.6029 10.316 18.9759 11.1115 18.9759 11.9902C18.9759 12.8689 18.6029 13.6644 18 14.2402",
    stroke: "#FFC000",
    strokeWidth: 1.54,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 2L6.089 2.53402C6.28188 3.69129 6.37832 4.26993 6.77519 4.62204C7.18918 4.98934 7.77614 5 9 5C10.2239 5 10.8108 4.98934 11.2248 4.62204C11.6217 4.26993 11.7181 3.69129 11.911 2.53402L12 2",
    stroke: "#FFC000",
    strokeWidth: 1.54,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7617 14.172C11.2833 15.0754 10.4129 15.6797 9.41852 15.6797C7.90872 15.6797 6.6848 14.2868 6.6848 12.5686V10.7908C6.6848 9.07258 7.90872 7.67969 9.41852 7.67969C10.4129 7.67969 11.2833 8.28395 11.7617 9.18743M5.76172 11.6797H9.68482",
    stroke: "#FFC000",
    strokeWidth: 1.54,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRechargeMobile);
export default __webpack_public_path__ + "static/media/iconRechargeMobile.0fb6a6ead46d918dad01e14b3f7c416d.svg";
export { ForwardRef as ReactComponent };